import { get, patch } from '@/api/base'

const routeEditorsApi = {
  get: async (projectUuid, weekday) => {
    const response = await get({ path: `projects/${projectUuid}/route_editors/${weekday}` })

    return response.success ? response.data.route_editor.stops : null
  },
  update: async (projectUuid, weekday, params) => {
    const response = await patch({
      path: `projects/${projectUuid}/route_editors/${weekday}/move_stop`,
      params: { ...params },
    })

    return response.success ? response.data.route_editor.stops : null
  },
}

export default routeEditorsApi
